<template>
    <div class="list-group" @click="$emit('click')">
        <div class="items">
            <div class="disGrid">
                <div class="title" :class="{ setTitle: index === 0 }" v-for="(item, index) in titleList" :key="index">{{ item }}</div>
            </div>
            <div class="disGridy">
                <div v-for="i in 4" :key="i">
                    <div class="imgBox">
                        <img src="@/assets/img/img-icon.png" alt="" />
                    </div>

                    <div class="titleBox">
                        <div class="title-span">这里是商品标题这里是商品标题这里是商品标题这里是商品标题</div>
                        <div class="disflex" style="align-items: center">
                            <div class="left">
                                <div class="price">￥100</div>
                            </div>
                            <div class="right">
                                <div class="but">立即购买</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="delete-box">
            <div class="handleType">
                <div class="iconfont" @click="remove()">
                    <i class="el-icon-delete"></i>
                </div>
                <div class="iconfont">
                    <i class="el-icon-copy-document" @click="copy()"></i>
                </div>
                <div class="iconfont" :class="{ disabled: index === 0 }" @click="downward()">
                    <i class="el-icon-arrow-up"></i>
                </div>
                <div class="iconfont" @click="upward()" :class="{ disabled: index >= finallyIndex }">
                    <i class="el-icon-arrow-down"></i>
                </div>
            </div>
        </div>

        <div class="delete-name">商品列表</div>
    </div>
</template>

<script>
export default {
    props: {
        index: {
            type: Number,
            default: null
        },
        finallyIndex: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            titleList: ['优选好物', '米面粮油', '饮料水饮', '休闲零食']
        };
    },
    methods: {
        remove() {
            this.$emit('remove', '');
        },
        copy() {
            this.$emit('copy', '');
        },
        downward() {
            this.$emit('downward', '');
        },
        upward() {
            this.$emit('upward', '');
        }
    }
};
</script>

<style lang="scss" scoped>
.on {
    scale: 1.01;
    .delete-box {
        display: block !important;
        border: 2px solid #0256ff !important;
        box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3) !important;
    }

    .delete-name {
        display: block !important;
        background: #4d88ff !important;
        color: #fff !important;
        &::before {
            background: #4d88ff !important;
        }
    }
}

.disabled {
    opacity: 0.4 !important;
}

.list-group:hover {
    scale: 1.01;
    box-shadow: 0 0 10px 0 rgba(24, 144, 255, 0.3);
    transition: all 0.2s;
}

.disflex {
    display: flex;
}

.list-group {
    width: 100%;
    position: relative;
    transition: all 0.2s;
    padding: 10px 0;
    background: rgb(245, 245, 245);

    .disGrid {
        display: grid;
        grid-template-columns: repeat(4, 1fr); /* 创建四个等宽的列 */
        gap: 10px; /* 可选，设置列与列之间的间隙 */
    }

    .disGridy {
        display: grid;
        grid-template-columns: repeat(2, 1fr); /* 创建四个等宽的列 */
        gap: 10px; /* 可选，设置列与列之间的间隙 */
    }

    .items {
        padding: 12px 0;
        background: #fff;
        .title {
            width: 100%;
            text-align: center;
            color: #333;
            font-size: 14px;
        }

        .setTitle {
            width: 100%;
            text-align: center;
            color: red;
            font-size: 14px;
            position: relative;
            &::before {
                content: '';
                position: absolute;
                left: 0;
                right: 0;
                margin: auto;
                width: 25px;
                height: 2px;
                background: red;
                bottom: -6px;
                border-radius: 10px;
            }
        }

        .imgBox {
            width: 100%;
            border-radius: 5px;
            // height: 240px;
            background: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 20px;
            padding: 10px 0;
            & > img {
                width: 90%;
                // height: 200px;
                height: 100px;
                background: #f3f9ff;
            }
        }

        .titleBox {
            // margin-top: 10px;
            background: #fff;
            padding: 10px;
            border-radius: 5px;

            .title-span {
                color: #333;
                /* 必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
                display: -webkit-box;
                /* 必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
                -webkit-box-orient: vertical;
                /*要显示的行数*/
                -webkit-line-clamp: 2;
                /* 溢出部分隐藏 */
                overflow: hidden;
                margin-bottom: 20px;
            }

            .left {
                flex: 1;
                .price {
                    color: red;
                }
            }

            .right {
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                align-items: flex-end;
                .tips {
                    padding: 2px;
                    border-radius: 5px;
                    border: 1px solid #666;
                    font-size: 10px;
                    color: #666;
                }

                .tips:first-child {
                    margin-right: 5px;
                }

                .but {
                    padding: 5px;
                    color: #666;
                    border: 1px solid #ccc;
                    font-size: 12px;
                    width: fit-content;
                    border-radius: 5px;
                    background: #fff;
                }
            }
        }
    }

    .delete-name {
        position: absolute;
        top: 0;
        background: #fff;
        left: -100px;
        width: 86px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        font-size: 13px;
        color: #666;
        border-radius: 3px;
        // display: none;

        &::before {
            content: '';
            position: absolute;
            width: 10px;
            height: 10px;
            background: #fff;
            -webkit-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 50%;
            right: -5px;
            margin-top: -5px;
        }
    }

    .delete-box {
        display: none;
        position: absolute;
        left: -2px;
        top: 0;
        width: 375px;
        height: 100%;
        border: 2px dashed #0256ff;
        .handleType {
            position: absolute;
            right: -43px;
            top: 0;
            width: 36px;
            border-radius: 4px;
            background-color: #0256ff;
            cursor: pointer;
            color: #fff;
            font-weight: 700;
            text-align: center;
            padding: 4px 0;

            .iconfont {
                padding: 5px 0;
            }
        }
    }
}
</style>